import dayjs from 'dayjs';

/**
 * Generates an array of years from a given minimum year up to the current year.
 *
 * @param {number} minYear - The minimum year to start from.
 * @returns {number[]} An array of years from minYear to the current year.
 */

export const generateYears = (minYear) => {
  const currentYear = new Date().getFullYear();
  let years = [];
  for (let year = minYear; year <= currentYear; year++) {
    years.push(year);
  }
  return years;
};

/*
 * Formats a date into 'YYYY.MM.DD.' format.
 * If the date is invalid or not provided, returns an empty string.
 * @param {Date | string | number} date - The date to format.
 * @returns {string} The formatted date string or an empty string.
 */

export const formatDate = (date) => {
  if (!date) return '';
  return dayjs(date).format('YYYY.MM.DD.');
};
